import LoadingState from '@/api/LoadingState';

const state = {
  runInformation: {},
  runDocuments: [],
  appointments: [],
  exercises: [],
  participant: {},
  currentExerciseId: null,
  loadingState: {
    runInfo: LoadingState.INITIAL,
    runDocuments: LoadingState.INITIAL,
    timetable: LoadingState.INITIAL
  }
}

export default state
